import { render, staticRenderFns } from "./etapa_8.vue?vue&type=template&id=9d46712e&scoped=true&"
import script from "./etapa_8.vue?vue&type=script&lang=js&"
export * from "./etapa_8.vue?vue&type=script&lang=js&"
import style0 from "./etapa_8.vue?vue&type=style&index=0&id=9d46712e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d46712e",
  null
  
)

export default component.exports